import * as React from 'react'
import './History.scss'
import { ActionType, orderType, orgListItemType, reducerStoreType, selectWalletType, userType, contListType } from "../../reducers/types";
import CustomDialog from "../../components/CustomUIComp/CustomDialog";
import OrderDetailModal from "./OrderDetailModal";
import OrderRefundModal from "./OrderRefundModal";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { StyledTableCell } from "../../components/CustomUIComp/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import alipayImg from '../../images/alipay.svg';
import wechatImg from '../../images/wechatpay.svg';
import alipayPlusImg from '../../images/alipayplus.svg';
import appleImg from '../../images/apple.svg';
import googleImg from '../../images/google.svg';
import creditCardImg from '../../images/card.svg';
import head from '../../images/head_light.svg'
import noDataIcon from '../../images/null_icon.svg';
import { injectIntl, IntlShape } from 'react-intl'
import { connect } from "react-redux";
import { Dispatch } from "redux";

interface IProps {
  dispatch: Dispatch<ActionType<any>>,
  list: orderType[],
  turnover: number,
  transactionNum: number,
  currency: string,
  users: userType[],
  orgList: orgListItemType[],
  selectWallet: selectWalletType,
  intl: IntlShape,
  refundModalOpen: boolean,
  orderDetailModalOpen: boolean,
  orderCountList: contListType[],
}

interface IState {
  modalOpen: boolean,
  openOrderNo: string,
  type: number,
  amt: number
}

const walletIcons: { [key: string]: any } = {
  'Alipay': alipayImg,
  'Wechat': wechatImg,
  'AlipayPlus': alipayPlusImg,
  'ApplePay': appleImg,
  'GooglePay': googleImg,
  'CreditCard': creditCardImg
}

class History extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {
      modalOpen: false,
      openOrderNo: '',
      type: 0,
      amt: 0
    }
  }

  closeDialog = () => {
    this.setState({
      openOrderNo: '',
      type: 0,
      amt: 0
    })
    this.props.dispatch({ type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: { open: false } })
  }
  openDialog = (orderNo: string, type: number, amt: number) => {
    this.setState({
      type: type,
      amt: amt
    })
    this.props.dispatch({
      type: 'GET_ORDERS', payload: {
        type: 'detail', data: {
          orderNo: orderNo
        }
      }
    })
    // this.props.dispatch({type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: {open: true}})
  }
  closeRefundDialog = () => {
    this.props.dispatch({ type: 'TOGGLE_REFUND_MODAL', payload: { open: false } })
    this.props.dispatch({ type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: { open: true } })
  }
  openRefundDialog = () => {
    this.props.dispatch({ type: 'TOGGLE_REFUND_MODAL', payload: { open: true } })
    this.props.dispatch({ type: 'TOGGLE_ORDER_DETAIL_MODAL', payload: { open: false } })
  }

  findCashierById = (cashierNo: string) => {
    for (var i in this.props.users) {
      if (this.props.users[i].cashierNo === cashierNo) {
        return this.props.users[i]
      }
    }
  }

  findOrgNameByPayOrg = (payOrg: string) => {
    for (var i in this.props.orgList) {
      if (this.props.orgList[i].payOrg === payOrg) {
        return this.props.orgList[i].name
      }
    }
    return payOrg || this.props.intl.formatMessage({ id: 'unknown' })
  }

  getWalletLogo = (wallet: string) => {
    const walletInfo = this.props.selectWallet[wallet];
    if (walletInfo && walletInfo.logo) {
      return walletInfo.logo;
    }
    return walletIcons[wallet] || null;
  }
  renderCashier = (cashierNo: string) => {
    let user;
    if (cashierNo) {
      user = this.findCashierById(cashierNo)
    }
    let { intl } = this.props
    if (user) {
      let name = user.name || user.loginNo
      let short = name.substr(0, 1)
      return (<span className='cashierTextAvatar' title={name}>{short.toUpperCase()}</span>)
    } else {
      return <img src={head} alt={intl.formatMessage({ id: 'CASHIER' })} className="cashierAvatar" />
    }
  }

  public render() {
    let { list, turnover, transactionNum, currency, intl, orderCountList } = this.props
    return (
      <div className="History">
        <div className="header">
          <h2>{intl.formatMessage({ id: 'orderList' })}</h2>
          <div className="stat">{intl.formatMessage({ id: 'turnover' })}: {(orderCountList || []).map((item, index) => (
            <span className="statItem" key={index}>{item.currency}:{(Number(item.payAmt.toFixed(2)) - Number(item.refundAmt.toFixed(2))).toFixed(2)}</span>
          ))}</div>
          {/* <div className="stat">{intl.formatMessage({ id: 'turnover' })}: {currency} {turnover.toFixed(2)} {intl.formatMessage({ id: 'transNum' })}:{transactionNum}</div> */}
        </div>
        <div className="orderList">
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>{intl.formatMessage({ id: 'CASHIER' })}/{intl.formatMessage({ id: 'payTime' })}/{intl.formatMessage({ id: 'orderNo' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'amt' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'payCurrency' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'payType' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'acquirer' }) || '收单机构'}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'remark' })}</StyledTableCell>
                <StyledTableCell align='center'>{intl.formatMessage({ id: 'buyer' })}</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {list.map((item, i) => {
                const walletLogo = this.getWalletLogo(item.wallet);
                return (<TableRow hover key={`${item.orderNo}-${i}`}
                  onClick={() => this.openDialog(item.orderNo, item.type, item.tradeAmt)}>
                  <StyledTableCell>
                    <div className="infoGroup">
                      {this.renderCashier(item.cashierNo || '')}
                      <div className="info">
                        <span>{item.tradeTime}</span>
                        <p>{item.orderNo}</p>
                      </div>
                    </div>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <span className={`amt ${item.type ? 'red' : ''}`}>
                      {item.type ? '-' : '+'}{item.tradeAmt}
                    </span>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {item.currency}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {walletLogo ? (
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                        <img src={walletLogo} className="walletIcon" alt={item.wallet} style={{ width: '24px', height: '24px' }} />
                        <span style={{ fontSize: '12px' }}>{this.props.selectWallet[item.wallet]?.name || item.wallet}</span>
                      </div>
                    ) : (
                      <span>{this.props.selectWallet[item.wallet]?.name || item.wallet}</span>
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {this.findOrgNameByPayOrg(item.payOrg || '')}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {item.tradeSummary}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {item.buyer || intl.formatMessage({ id: 'unknown' })}
                  </StyledTableCell>
                </TableRow>)
              })}
            </TableBody>
          </Table>
          {list.length === 0 ?
            <div className="noData">
              <img src={noDataIcon} alt="no data" />
              <p>{intl.formatMessage({ id: 'noData' })}</p>
            </div>
            : null}
        </div>
        <CustomDialog open={this.props.orderDetailModalOpen}
          title={intl.formatMessage({ id: 'orderDetail' })}
          showActions={false}
          content={<OrderDetailModal
            orderType={this.state.type}
            openOrderNo={this.state.openOrderNo}
            orderAmt={this.state.amt}
            onRefund={this.openRefundDialog}
          />}
          handleClose={this.closeDialog} />

        <CustomDialog open={this.props.refundModalOpen}
          title={intl.formatMessage({ id: 'refund' })}
          showActions={false}
          content={<OrderRefundModal origin="orders" onClose={this.closeRefundDialog} />}
          handleClose={this.closeRefundDialog} />
      </div>
    );
  }
}
export default injectIntl(connect((state: reducerStoreType) => {
  return {
    refundModalOpen: state.orders.refundModalOpen,
    orderDetailModalOpen: state.orders.orderDetailModalOpen,
    orderCountList: state.orders.contList || []
  }
})(History))